import { useClipboard } from 'use-clipboard-copy';

export default function useClipboardHook() {
    const clipboard = useClipboard();
    return [clipboard.copy];
}


